import type { Locale } from "@taunggyi-plus/domain";

export const supportedLocales: readonly Locale[] = ["en", "my", "shn", "zh"];

const messages = {
  en: {
    resetYourPassword: "Reset your password",
    sendRecoveryEmail: "Send recovery email",
    forgotPassword: "Forgot password?",
    brand: "TaungGyi Link",
    tagline: "Our City, Linked.",
    notifications: "Notifications",
    events: "Events",
    search: "Search",
    home: "Home",
    services: "Services",
    workspace: "Workspace",
    more: "More",
    dashboard: "Dashboard",
    myServices: "My Services",
    orders: "Orders",
    audit: "Audit",
    finance: "Finance",
    signInRequired: "Sign in to continue",
    protectedHelp:
      "This workspace contains private business information. Sign in with your approved account to continue.",
    email: "Email address",
    loginIdentifier: "Email, phone or username",
    registrationContact: "Email or phone number",
    username: "Username",
    phoneHelp: "For Myanmar phone numbers, use 09… or +959…",
    password: "Password",
    name: "Name",
    signIn: "Sign in",
    signingIn: "Signing in…",
    createAccount: "Create account",
    creatingAccount: "Creating account…",
    needAccount: "Need an account? Create one",
    haveAccount: "Already have an account? Sign in",
    accountCreated: "Account created. You can now continue.",
    authLoading: "Checking your account…",
    authUnavailable: "Authentication is not configured for this app.",
    notFoundTitle: "Page not found",
    notFoundHelp: "The page may have moved, or the address may be incorrect.",
    serverErrorTitle: "Something went wrong",
    serverErrorHelp: "We could not load this page safely. Your information has not been changed.",
    goHome: "Go to home",
    reload: "Try again",
    openWorkspace: "Open your workspace",
    openWorkspaceHelp: "Use the menu to manage services, requests, and daily work.",
    skip: "Skip to content",
    language: "Language",
    preview: "Service status",
    ready: "Ready for your next action",
    connected: "Platform connected",
    local: "Service API is not configured",
    offline: "You are offline. Saved screens remain available; new actions need a connection.",
  },
  my: {
    resetYourPassword: "သင့်စကားဝှက်ကို ပြန်လည်သတ်မှတ်ပါ",
    sendRecoveryEmail: "စကားဝှက်ပြန်လည်သတ်မှတ်ရန် အီးမေးလ်ပို့မည်",
    forgotPassword: "စကားဝှက် မေ့နေပါသလား။",
    brand: "TaungGyi Link",
    tagline: "ချိတ်ဆက်နေတဲ့ ငါတို့မြို့",
    notifications: "အသိပေးချက်များ",
    events: "ပွဲတော်များ",
    search: "ရှာဖွေရန်",
    home: "ပင်မ",
    services: "ဝန်ဆောင်မှု",
    workspace: "လုပ်ငန်းခွင်",
    more: "နောက်ထပ်",
    dashboard: "ဒက်ရှ်ဘုတ်",
    myServices: "ကျွန်ုပ်၏ ဝန်ဆောင်မှုများ",
    orders: "မှာယူမှုများ",
    audit: "စစ်ဆေးမှတ်တမ်း",
    finance: "ငွေကြေး",
    signInRequired: "ဆက်လုပ်ရန် အကောင့်ဝင်ပါ",
    protectedHelp:
      "ဤလုပ်ငန်းခွင်တွင် ကိုယ်ပိုင်လုပ်ငန်းအချက်အလက်များ ပါဝင်သည်။ အတည်ပြုထားသော အကောင့်ဖြင့် ဝင်ပါ။",
    email: "အီးမေးလ်လိပ်စာ",
    loginIdentifier: "အီးမေးလ်၊ ဖုန်း သို့မဟုတ် အသုံးပြုသူအမည်",
    registrationContact: "အီးမေးလ် သို့မဟုတ် ဖုန်းနံပါတ်",
    username: "အသုံးပြုသူအမည်",
    phoneHelp: "မြန်မာဖုန်းနံပါတ်ကို 09… သို့မဟုတ် +959… ဖြင့် ထည့်ပါ",
    password: "စကားဝှက်",
    name: "အမည်",
    signIn: "အကောင့်ဝင်မည်",
    signingIn: "အကောင့်ဝင်နေသည်…",
    createAccount: "အကောင့်ဖန်တီးမည်",
    creatingAccount: "အကောင့်ဖန်တီးနေသည်…",
    needAccount: "အကောင့်လိုပါသလား။ ဖန်တီးမည်",
    haveAccount: "အကောင့်ရှိပြီးသားလား။ အကောင့်ဝင်မည်",
    accountCreated: "အကောင့်ဖန်တီးပြီးပါပြီ။ ဆက်လက်အသုံးပြုနိုင်ပါပြီ။",
    authLoading: "အကောင့်ကို စစ်ဆေးနေသည်…",
    authUnavailable: "ဤအက်ပ်အတွက် အကောင့်စနစ် မသတ်မှတ်ရသေးပါ။",
    notFoundTitle: "စာမျက်နှာ မတွေ့ပါ",
    notFoundHelp: "စာမျက်နှာကို ရွှေ့ထားနိုင်သည် သို့မဟုတ် လိပ်စာ မှားနေနိုင်သည်။",
    serverErrorTitle: "တစ်ခုခု မှားယွင်းနေသည်",
    serverErrorHelp:
      "ဤစာမျက်နှာကို လုံခြုံစွာ မဖွင့်နိုင်ပါ။ သင့်အချက်အလက်များကို မပြောင်းလဲထားပါ။",
    goHome: "ပင်မသို့ သွားမည်",
    reload: "ထပ်ကြိုးစားမည်",
    openWorkspace: "သင့်လုပ်ငန်းခွင်ကို ဖွင့်ပါ",
    openWorkspaceHelp: "ဝန်ဆောင်မှု၊ တောင်းဆိုမှုနှင့် နေ့စဉ်လုပ်ငန်းများကို မီနူးမှ စီမံပါ။",
    skip: "အကြောင်းအရာသို့ သွားမည်",
    language: "ဘာသာစကား",
    preview: "ဝန်ဆောင်မှုအခြေအနေ",
    ready: "နောက်လုပ်ဆောင်ချက်အတွက် အဆင်သင့်",
    connected: "ပလက်ဖောင်း ချိတ်ဆက်ထားသည်",
    local: "ဝန်ဆောင်မှု API မသတ်မှတ်ရသေးပါ",
    offline:
      "အင်တာနက်ပြတ်နေသည်။ သိမ်းထားသောစာမျက်နှာများကို ကြည့်နိုင်ပြီး လုပ်ဆောင်ချက်အသစ်အတွက် အင်တာနက်လိုသည်။",
  },
  shn: {
    resetYourPassword: "တင်ႈၶေႃႈလပ်ႉၸဝ်ႈၵဝ်ႇၶိုၼ်း",
    sendRecoveryEmail: "သူင်ႇဢီးမေးလ် တႃႇတင်ႈၶေႃႈလပ်ႉၶိုၼ်း",
    forgotPassword: "လိုမ်းၶေႃႈလပ်ႉႁိုဝ်?",
    brand: "TaungGyi Link",
    tagline: "ဝဵင်းႁဝ်း၊ ၵပ်းသိုပ်ႇဝႆႉ။",
    notifications: "ၶေႃႈပွင်ႇၶၢဝ်ႇ",
    events: "ပွႆးသဘိင်ႇ",
    search: "ႁႃ",
    home: "ၼႃႈႁႅၵ်ႈ",
    services: "ဝန်ဆောင်ႈ",
    workspace: "တီႈႁဵတ်းၵၢၼ်",
    more: "ထႅင်ႈ",
    dashboard: "ၼႃႈၸတ်းၵၢၼ်",
    myServices: "ဝန်ဆောင်ႈၶႃႈ",
    orders: "ၵၢၼ်သင်ႇသိုဝ်ႉ",
    audit: "မၢႆတွင်းၵူတ်ႇထတ်း",
    finance: "ငိုၼ်းတွင်း",
    signInRequired: "ၶဝ်ႈဢၵွင်ႉတႃႇႁဵတ်းသိုပ်ႇ",
    protectedHelp: "တီႈႁဵတ်းၵၢၼ်ၼႆႉမီးၶေႃႈမုၼ်းသုၼ်ႇတူဝ်။ ၶဝ်ႈဢၵွင်ႉဢၼ်ယိုၼ်ယၼ်ဝႆႉ။",
    email: "ဢီးမေးလ်",
    loginIdentifier: "ဢီးမေးလ်၊ ၾူၼ်း ဢမ်ႇၼၼ် ၸိုဝ်ႈၽူႈၸႂ်ႉ",
    registrationContact: "ဢီးမေးလ် ဢမ်ႇၼၼ် မၢႆၾူၼ်း",
    username: "ၸိုဝ်ႈၽူႈၸႂ်ႉ",
    phoneHelp: "မၢႆၾူၼ်းမိူင်းမၢၼ်ႈ ၸႂ်ႉ 09… ဢမ်ႇၼၼ် +959…",
    password: "မၢႆလပ်ႉ",
    name: "ၸိုဝ်ႈ",
    signIn: "ၶဝ်ႈဢၵွင်ႉ",
    signingIn: "တိုၵ်ႉၶဝ်ႈဢၵွင်ႉ…",
    createAccount: "ႁဵတ်းဢၵွင်ႉမႂ်ႇ",
    creatingAccount: "တိုၵ်ႉႁဵတ်းဢၵွင်ႉ…",
    needAccount: "လူဝ်ႇဢၵွင်ႉႁႃႉ။ ႁဵတ်းဢၵွင်ႉမႂ်ႇ",
    haveAccount: "မီးဢၵွင်ႉယဝ်ႉႁႃႉ။ ၶဝ်ႈဢၵွင်ႉ",
    accountCreated: "ႁဵတ်းဢၵွင်ႉယဝ်ႉ။ သိုပ်ႇၸႂ်ႉလႆႈယဝ်ႉ။",
    authLoading: "တိုၵ်ႉထတ်းဢၵွင်ႉ…",
    authUnavailable: "ပႆႇတင်ႈၵၢၼ်ၶဝ်ႈဢၵွင်ႉတႃႇ app ၼႆႉ။",
    notFoundTitle: "ႁႃၼႃႈဢမ်ႇႁၼ်",
    notFoundHelp: "ၼႃႈၼႆႉၸၢင်ႈယၢႆႈတီႈ သို့ လိၵ်ႈႁူဝ်ၽိတ်း။",
    serverErrorTitle: "မီးလွင်ႈၽိတ်းပိူင်ႈ",
    serverErrorHelp: "ဢမ်ႇၸၢင်ႈပိုတ်ႇၼႃႈၼႆႉလႆႈလွတ်ႈၽေး။ ၶေႃႈမုၼ်းၸဝ်ႈၵဝ်ႇဢမ်ႇလႅၵ်ႈလၢႆႈ။",
    goHome: "ၵႂႃႇၼႃႈႁႅၵ်ႈ",
    reload: "ၸၢမ်းထႅင်ႈ",
    openWorkspace: "ပိုတ်ႇတီႈႁဵတ်းၵၢၼ်",
    openWorkspaceHelp: "ၸတ်းၵၢၼ်ဝန်ဆောင်ႈ၊ ၶေႃႈယွၼ်းလႄႈၵၢၼ်ၵူႈဝၼ်းၼႂ်းမီႇၼူး။",
    skip: "ၵႂႃႇတီႈၼႂ်းၵႂၢမ်း",
    language: "ၽႃႇသႃႇ",
    preview: "ငဝ်းလၢႆးဝန်ဆောင်ႈ",
    ready: "တူဝ်ႈတၼ်းတႃႇႁဵတ်းသိုပ်ႇ",
    connected: "ၵပ်းသိုပ်ႇ platform ယဝ်ႉ",
    local: "ပႆႇတင်ႈ service API",
    offline: "ဢမ်ႇမီး internet။ တူၺ်းၼႃႈဢၼ်သိမ်းဝႆႉလႆႈ၊ တႃႇႁဵတ်းမႂ်ႇလူဝ်ႇ internet။",
  },
  zh: {
    resetYourPassword: "重置您的密码",
    sendRecoveryEmail: "发送密码重置邮件",
    forgotPassword: "忘记密码？",
    brand: "TaungGyi Link",
    tagline: "我们的城市，紧密相连。",
    notifications: "通知",
    events: "活动",
    search: "搜索",
    home: "首页",
    services: "服务",
    workspace: "工作台",
    more: "更多",
    dashboard: "仪表板",
    myServices: "我的服务",
    orders: "订单",
    audit: "审计",
    finance: "财务",
    signInRequired: "登录以继续",
    protectedHelp: "此工作区包含私密业务信息。请使用已获批准的账户登录。",
    email: "电子邮箱",
    loginIdentifier: "邮箱、手机号或用户名",
    registrationContact: "邮箱或手机号",
    username: "用户名",
    phoneHelp: "缅甸手机号请使用 09… 或 +959…",
    password: "密码",
    name: "姓名",
    signIn: "登录",
    signingIn: "正在登录…",
    createAccount: "创建账户",
    creatingAccount: "正在创建账户…",
    needAccount: "需要账户？立即创建",
    haveAccount: "已有账户？登录",
    accountCreated: "账户已创建，现在可以继续。",
    authLoading: "正在检查账户…",
    authUnavailable: "此应用尚未配置身份验证。",
    notFoundTitle: "找不到页面",
    notFoundHelp: "该页面可能已移动，或地址不正确。",
    serverErrorTitle: "出现问题",
    serverErrorHelp: "无法安全加载此页面。您的信息未被更改。",
    goHome: "返回首页",
    reload: "重试",
    openWorkspace: "打开您的工作台",
    openWorkspaceHelp: "通过菜单管理服务、请求和日常工作。",
    skip: "跳到主要内容",
    language: "语言",
    preview: "服务状态",
    ready: "可以进行下一步",
    connected: "平台已连接",
    local: "服务 API 尚未配置",
    offline: "您当前离线。仍可查看已缓存页面，新操作需要网络连接。",
  },
} as const;

const appCopy: Record<Locale, Record<string, { role: string; welcome: string }>> = {
  en: {
    customer: { role: "Customer", welcome: "Our City, Linked." },
    admin: {
      role: "Administration",
      welcome: "Operate partners, approvals, notifications, and support safely.",
    },
    hotel: {
      role: "Link Stay Partner",
      welcome: "Manage rooms, availability, and booking requests.",
    },
    merchant: {
      role: "Link Food Partner",
      welcome: "Manage your shop, catalog, and cash-on-delivery orders.",
    },
    "delivery-owner": {
      role: "Delivery Owner",
      welcome: "Coordinate riders, assignments, and delivery records.",
    },
    "delivery-rider": {
      role: "Delivery Rider",
      welcome: "Receive assignments and complete deliveries reliably.",
    },
    taxi: {
      role: "Link Ride Partner",
      welcome: "Manage ride groups, drivers, phone listings, and records.",
    },
  },
  my: {
    customer: { role: "ဖောက်သည်", welcome: "ချိတ်ဆက်နေတဲ့ ငါတို့မြို့" },
    admin: {
      role: "စီမံခန့်ခွဲမှု",
      welcome: "ပါတနာ၊ အတည်ပြုမှုနှင့် အကူအညီများကို လုံခြုံစွာ စီမံပါ။",
    },
    hotel: { role: "ဟိုတယ်ပါတနာ", welcome: "အခန်း၊ ရရှိနိုင်မှုနှင့် ဘွတ်ကင်များကို စီမံပါ။" },
    merchant: {
      role: "ဆိုင်ပါတနာ",
      welcome: "ဆိုင်၊ ပစ္စည်းစာရင်းနှင့် ငွေချေမှာယူမှုများကို စီမံပါ။",
    },
    "delivery-owner": {
      role: "ပို့ဆောင်ရေးပိုင်ရှင်",
      welcome: "ပို့ဆောင်သူ၊ တာဝန်နှင့် မှတ်တမ်းများကို စီမံပါ။",
    },
    "delivery-rider": {
      role: "ပို့ဆောင်သူ",
      welcome: "တာဝန်များလက်ခံပြီး ယုံကြည်စွာ ပို့ဆောင်ပါ။",
    },
    taxi: {
      role: "တက္ကစီပါတနာ",
      welcome: "တက္ကစီအဖွဲ့၊ ယာဉ်မောင်းနှင့် ဖုန်းစာရင်းများကို စီမံပါ။",
    },
  },
  shn: {
    customer: { role: "လုၵ်ႈၵႃႉ", welcome: "ဝဵင်းႁဝ်း၊ ၵပ်းသိုပ်ႇဝႆႉ။" },
    admin: { role: "ၽူႈၸတ်းၵၢၼ်", welcome: "ၸတ်းၵၢၼ် partner လႄႈၵၢၼ်ယိုၼ်ယၼ်ႁႂ်ႈႁူမ်ႇလူမ်ႈ။" },
    hotel: { role: "Partner ႁူင်းလိုဝ်ႈသဝ်း", welcome: "ၸတ်းၵၢၼ်ႁွင်ႈလႄႈၶေႃႈယွၼ်းၸွင်း။" },
    merchant: { role: "Partner ႁၢၼ်ႉ", welcome: "ၸတ်းၵၢၼ်ႁၢၼ်ႉ၊ ၶူဝ်းလႄႈၶေႃႈသင်ႇ။" },
    "delivery-owner": { role: "ၸဝ်ႈၶွင်ၵၢၼ်သူင်ႇ", welcome: "ၸတ်းၵၢၼ်ၽူႈသူင်ႇလႄႈၼႃႈၵၢၼ်။" },
    "delivery-rider": { role: "ၽူႈသူင်ႇ", welcome: "ႁပ်ႉၼႃႈၵၢၼ်လႄႈသူင်ႇႁႂ်ႈယဝ်ႉတူဝ်ႈ။" },
    taxi: { role: "Partner တႅၵ်ႇသီႇ", welcome: "ၸတ်းၵၢၼ်ၸုမ်း၊ ၽူႈႁေႃႈလႄႈမၢႆၾူၼ်း။" },
  },
  zh: {
    customer: { role: "顾客", welcome: "我们的城市，紧密相连。" },
    admin: { role: "平台管理", welcome: "安全管理合作伙伴、审核、通知和支持。" },
    hotel: { role: "酒店合作伙伴", welcome: "管理房间、可订状态和预订申请。" },
    merchant: { role: "商户合作伙伴", welcome: "管理商店、商品目录和货到付款订单。" },
    "delivery-owner": { role: "配送负责人", welcome: "协调骑手、任务和配送记录。" },
    "delivery-rider": { role: "配送骑手", welcome: "接收任务并可靠地完成配送。" },
    taxi: { role: "出租车合作伙伴", welcome: "管理出租车组、司机、电话列表和记录。" },
  },
};

export type MessageKey = keyof (typeof messages)["en"];

export function translate(locale: Locale, key: MessageKey): string {
  return messages[locale]?.[key] ?? messages.en[key];
}

export function translateApp(
  locale: Locale,
  appId: string,
  field: "role" | "welcome",
  fallback: string,
): string {
  return appCopy[locale]?.[appId]?.[field] ?? appCopy.en[appId]?.[field] ?? fallback;
}
